import { apiClient } from "./core/client";
import type { GarageDto, UserRole } from "@/types/dto";

export async function getMyGarage(): Promise<GarageDto> {
  const { data } = await apiClient.get("/api/garage");
  return data;
}

export async function updateMyGarage(payload: Partial<Pick<GarageDto, "name" | "email" | "phone">> & { brandName?: string; vatNumber?: string }): Promise<GarageDto> {
  const { data } = await apiClient.patch("/api/garage", payload);
  return data;
}

export async function updateProfile(payload: { firstName?: string; lastName?: string; role?: string }) {
  const { data } = await apiClient.patch<{ id: string; email: string; firstName: string; lastName: string; role: UserRole; garageId: string | null }>("/api/garage/profile", payload);
  return data;
}
